import { t } from "ttag";

export const LONG_CONVO_MSG_LENGTH_THRESHOLD = 120000;

// NOTE: this is not ideal, but will get fixed w/ BOT-189 allowing us to use fixed entity_ids
export const FIXED_METABOT_IDS = {
  DEFAULT: 1 as const,
  EMBEDDED: 2 as const,
};

export const METABOT_REQUEST_IDS = {
  EMBEDDED: "c61bf5f5-1025-47b6-9298-bf1827105bb6",
};

export const METABOT_ERR_MSG = {
  get default() {
    return t`Sorry, I ran into an error. Could you please try that again?`;
  },
  get agentOffline() {
    return t`Metabot is currently offline. Please try again later`;
  },
};

export const TOOL_CALL_MESSAGES: Record<string, string | undefined> = {
  get construct_notebook_query() {
    return t`Creating a query..`;
  },
  get analyze_data() {
    return t`Analyzing the data..`;
  },
  get analyze_chart() {
    return t`Inspecting the visualization..`;
  },
  get list_available_fields() {
    return "getting Field Values";
  },
  get search_data_sources() {
    return t`Checking available data sources..`;
  },
  get search_metabase_documentation() {
    return t`Consulting the docs..`;
  },
  get get_table_schema_metadata() {
    return t`Fetching table schema metadata..`;
  },
  get navigate_user_to_view_chart() {
    return t`Navigating to the chart view..`;
  },
  get get_sample_data_from_viewing_context() {
    return t`Retrieving sample data from the current context..`;
  },
  get get_user_details_and_current_time() {
    return t`Checking your user details and current time..`;
  },
  get get_quey_data_to_fix_from_sql_error() {
    return t`Gathering query data to diagnose the SQL error..`;
  },
  get get_database_schema() {
    return t`Loading database schema..`;
  },
  get get_chart_generation_schema_sample() {
    return t`Preparing chart generation schema sample..`;
  },
  get get_chart_or_dashboard_image() {
    return t`Getting chart/dashboard image..`;
  },
  get current_user_viewing_context() {
    return t`Inspecting your current viewing context..`;
  },
  get current_user_chart_configs() {
    return t`Loading your chart configurations..`;
  },
  get get_messages_history() {
    return t`Retrieving message history..`;
  },
  get display_fixed_sql_in_editor() {
    return t`Displaying the sql..`;
  },
};
